import { AuthProvider } from './auth.models';

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
}

export enum UserType {
  Private = 'PRIVATE',
  Business = 'BUSINESS',
}

export interface Profile {
  name?: string;
  surname?: string;
  dateOfBirth?: string;
  placeOfBirth?: string;
  citizenship?: string;
  gender?: Gender;
  residentialAddress?: string;
  fiscalCode?: string;
  email: string;
  providers: AuthProvider[];
  company: boolean;
  companyName?: string;
  vatNumber?: string;
  legalRepresentative?: string;
  companyAddress?: string;
  postcode?: string;
  municipality?: string;
  province?: string;
  countryCode?: string;
  companyPostcode?: string;
  companyMunicipality?: string;
  companyProvince?: string;
  companyCountryCode?: string;
  companySDICode?: string;
  companyPEC?: string;
}

export interface GetProfileResponse {
  user: Profile;
}

export interface UpdateUserPasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export type UpdateUserRequest = Partial<Omit<Profile, 'email' | 'providers'>>;
